<template>
    <div>
        <div class="module">
            <header class="module__header">
                <h1>Welcome!</h1>
            </header>

            <section class="module__body">
                <p class="mb-20">
                    The goTenna Management Portal provides your organizational admins with tools for managing users,
                    groups, frequency sets and more. As a member of the Organization, you will be part of one or more
                    groups that have frequencies attached to them.
                </p>

                <p class="mb-20">
                    To the left, you can access our
                    <a
                        :href="knowledgeBaseUrl"
                        target="_blank"
                        >Pro Knowledge Base and Support Portal</a
                    >, clicking on the link will open the knowledge base in a new tab.
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import KnowledgeBase from '@/constants/knowledge-base'

export default {
    data() {
        return {
            knowledgeBaseUrl: KnowledgeBase.KNOWLEDGE_BASE_URL,
        }
    },
}
</script>
